// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ItemReplacements from "@guestsupply/App/Components/ProductDetails/ItemReplacements";
import { CustomAppState } from "@guestsupply/App/Store/Reducers";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { connect } from "react-redux";

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: CustomAppState) => {
    return {
        itemReplacements: state.xItemReplacements,
    };
};

export interface ProductDetailsItemReplacementsStyles {}

export const itemReplacementsStyles: ProductDetailsItemReplacementsStyles = {};

const styles = itemReplacementsStyles;

const ProductDetailsItemReplacements = ({ product, itemReplacements }: Props) => {
    const hasItemReplacements = itemReplacements[product?.id];

    if (!product || !hasItemReplacements?.carouselItemReplacement) {
        return null;
    }

    return <ItemReplacements />;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ProductDetailsItemReplacements)),
    definition: {
        displayName: "Item Replacements",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
